import React, { useEffect, useState } from "react";

import GenericToolbar from "components/toolbars/GenericToolbar";
import PageContainer from "design/layouts/PageContainer";
import { t } from "i18next";
import useNavitems from "qpr-base/apihooks/useNavitems";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getFileApiURL as fileURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import { useHistory } from "react-router-dom";

interface AdminToolCard {
  title: string;
  icon?: string;
  link?: string;
  backgroundLink?: string;
}

const useStyles = makeThemedStyles("", (theme) => ({
  backgroundImage: {
    width: "27.5vw",
    height: "187px",

    transition: "all 0.5s",
    position: "absolute",
    backgroundBlendMode: "normal",
    backgroundSize: "cover",
    borderRadius: "35px",
    zIndex: -1,
    // justifySelf: 'center'
  },
  name: {
    fontSize: "2.4em",
    color: "white",
    zIndex: 1,
    textAlign: "center",
    marginTop: "0.955em",
  },
  icon: {
    display: "block",
    marginBottom: 0,
    marginTop: "4.92em",
    marginInlineStart: "auto",
    marginInlineEnd: "auto",
    width: "50px",
  },
}));

const Card = ({ title, icon, link, backgroundLink }: AdminToolCard) => {
  const history = useHistory();
  const ctx = useAppContext();
  const linkHandler = () => {
    history.push(`/${ctx.tenant || "demo2023"}${link}`);
  };
  const fallbackUrl = fileURL("/icons/LocationCity.svg");
  const backgroundUrl = `${ctx.serverURL}${backgroundLink}`;
  const iconUrl = `${ctx.serverURL}${icon}`;
  const classes = useStyles();
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={() => linkHandler()}
      onKeyDown={() => linkHandler()}
      role="button"
      tabIndex={0}
      style={{
        width: "27.5vw",
        minHeight: "260px",
        justifyContent: "center",
        margin: "auto",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={classes.backgroundImage}
        style={{
          opacity: hovered ? "0.45" : "0.8",
          transition: "opacity 1s",
        }}
      >
        <div
          className={classes.backgroundImage}
          style={{
            opacity: hovered ? "0" : "1",
            transition: "opacity 1s",
          }}
        />
        <img
          src={backgroundUrl}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            zIndex: "-2",
            position: "relative",
            objectFit: "fill",
            borderRadius: "35px",
          }}
        />
      </div>
      <div
        className={classes.backgroundImage}
        style={{ background: "rgb(14,37,106)", zIndex: -2 }}
      />

      <img
        className={classes.icon}
        src={icon ? iconUrl : fallbackUrl}
        alt="Icon"
        onError={(e) => {
          if (e.currentTarget.src !== fallbackUrl)
            e.currentTarget.src = fallbackUrl;
        }}
      />
      <div className={classes.name}>{t(`adminTools.${title}`)}</div>
    </div>
  );
};

const AdminTools = () => {
  const navi = useNavitems();
  const [items, setItems] = useState<AdminToolCard[]>([]);
  useEffect(() => {
    const itms = navi?.data?.children?.find(
      (itm) => itm.title === "Admin Tools"
    )?.children;
    setItems((prev) => {
      if (itms && itms.length) return itms as AdminToolCard[];
      return prev;
    });
  }, [navi]);

  return (
    <div style={{ width: "100%" }}>
      <GenericToolbar
        title={t("navItems.Admin Tools")}
        icon={"/icons/navitems/AdminTools.svg"}
        hidePeriodSelector={true}
      />
      <PageContainer>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "33.3% 33.3% 33.3%",
            marginTop: "50px",
          }}
        >
          {items.map((item) => (
            <Card {...item} />
          ))}
        </div>
      </PageContainer>
    </div>
  );
};

export default AdminTools;
